/* unplugin-vue-components disabled */import { render } from "./commentList.vue?vue&type=template&id=56cfc15c&scoped=true"
import script from "./commentList.vue?vue&type=script&lang=js"
export * from "./commentList.vue?vue&type=script&lang=js"

import "./commentList.vue?vue&type=style&index=0&id=56cfc15c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cfc15c"]])

export default __exports__